/**
 * HR Calendar connector API client — Microsoft Graph shared-calendar sync.
 * Backed by services/api/src/routes/hr_calendar.py. HR role; session cookie + RLS.
 */
import { apiRequest } from './client'

export interface CalendarConfig {
  /** Runtime on/off HR controls (org_config.calendar_sync_enabled). */
  syncEnabled: boolean
  mailbox: string | null
  /** Passive Graph-reachability probe. */
  connected: boolean
  /**
   * Deploy-time master switch (MS_GRAPH_CALENDAR_SYNC_ENABLED). Leave only syncs
   * when connected && capabilityEnabled && syncEnabled are all true.
   */
  capabilityEnabled: boolean
  detail: string | null
}

export interface CalendarActivityRow {
  when: string
  action: string
  detail: string
}

export interface CalendarActivityLog {
  rows: CalendarActivityRow[]
}

export interface CalendarTestResult {
  ok: boolean
  detail: string
}

/** GET /api/v1/hr/calendar/config */
export async function getCalendarConfig(): Promise<CalendarConfig> {
  return apiRequest<CalendarConfig>('/api/v1/hr/calendar/config')
}

/** PATCH /api/v1/hr/calendar/config — flip the runtime calendar-sync switch. */
export async function setCalendarSync(syncEnabled: boolean): Promise<CalendarConfig> {
  return apiRequest<CalendarConfig>('/api/v1/hr/calendar/config', {
    method: 'PATCH',
    body: { syncEnabled },
  })
}

/** POST /api/v1/hr/calendar/test — real create→delete round-trip on the mailbox. */
export async function testCalendarConnection(): Promise<CalendarTestResult> {
  return apiRequest<CalendarTestResult>('/api/v1/hr/calendar/test', { method: 'POST' })
}

/** GET /api/v1/hr/calendar/activity — last 20 calendar_event.* audit rows. */
export async function getCalendarActivity(): Promise<CalendarActivityLog> {
  return apiRequest<CalendarActivityLog>('/api/v1/hr/calendar/activity')
}
